import { createSelector } from 'reselect';
import { AppState } from 'store/types/Store';
import { getCurrentSeasonCropCode } from './seasonSelectors';

export const getCrops = (state: AppState) => state.crops;

export const getCurrentSeasonCrop = createSelector(
  [getCrops, getCurrentSeasonCropCode],
  (crops, currentCropName) =>{
    if (!currentCropName){
      return undefined;
    }

    const crop = crops[currentCropName];

    // Some unsupported crops flow through season data - check if an ID exists for them to be valid
    if (crop && !crop['dfp-uuid']) {
      return undefined
    }

    return crops[currentCropName];
  }
);

export const getCurrentSeasonCropId = createSelector(
  [getCurrentSeasonCrop],
  (cropInfo) => {

    if (!cropInfo) {
      return '';
    }

    return cropInfo['legacy-id'];
  }
);

export const getCurrentSeasonCropName = createSelector(
  [getCurrentSeasonCrop],
  (cropInfo) => {

    if (!cropInfo) {
      return '';
    }

    return cropInfo.name;
  }
);
